import React, {Component} from 'react';
import {VictoryChart, VictoryZoomContainer, VictoryLine,createContainer,VictoryVoronoiContainer,VictoryCursorContainer, VictoryBrushContainer, VictoryAxis} from 'victory'
import {dk_blue, dk_gray, dk_yellow} from "../constants/style";
import {connect} from "react-redux";
import {seekCellHistory, seekHistory} from "../redux/actionCreators/history";
import {
    cellHistorySelector,
    cellsSelector,
    historyseekingSelector,
    historySelector
} from "../redux/reducers/historyReducer";
import {openBatterySelector} from "../redux/reducers/openReducer";
import moment from "moment";
import {PulseLoader} from "react-spinners";
import strings from "../screenLocalisation/history";
import Dropdown from 'react-dropdown'

const VictoryZoomCursorContainer = createContainer("zoom", "voronoi");

class History extends Component {
    constructor(props) {
        super(props);
        this.state = { scrollOn: true, positionX: 0 , positionY: 0, width: 1000, height: 1000, maxPoints: 1000, showing: {label: strings.batteryTensionButton, value: 0} };
        this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
    }

    _onMouseMove(e){
        this.setState({ positionX: e.screenX, positionY: e.screenY });
        console.log(this.state.positionX)
    }

    componentDidMount() {
        this.props.seekHistory()
        this.updateWindowDimensions();
        window.addEventListener('resize', this.updateWindowDimensions);
        let victoryChart = document.getElementById('victoryChart');


    }


    componentWillUnmount() {
        window.removeEventListener('resize', this.updateWindowDimensions);
    }

    updateWindowDimensions() {
        this.setState({ width: window.innerWidth, height: window.innerHeight });
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.updateData(nextProps)
    }

    updateData(nextProps) {
        if(nextProps.data.length > 0) {
            let newData = this.filterData(nextProps, 10)
            this.entireDomain = this.getEntireDomain({data: newData});
            this.initialDomain = this.getInitialDomain({data: newData})
            this.setState({
                zoomedXDomain: this.entireDomain.x,
                data: newData
            })
        }
    }

    setValueType(v) {
        this.setState({
            showing: v,
            // zoomedXDomain: {x: this.state.zoomedXDomain.x}
        }, () => this.updateData(this.props))
    }


    onDomainChange(domain) {
        this.setState({
            zoomedXDomain: domain.x,
        })
    }

    getEntireDomain(props) {
        const {data, battery} = props;
        return {
            // x: [data[data.length-1].x, data[0].x]
            x: [moment(this.props.battery.battery_createdAt, 'YYYY-MM-DDTHH:mm:ss').toDate(), data[0][0].x]
            //x: [moment(data[0][0].x).add(-2, 'days').toDate(), data[0][0].x]
        }
    }

    getInitialDomain(props) {
        const {data, battery} = props;
        return {
            x: [moment(data[0][0].x).add(-2, 'days').toDate(), data[0][0].x]
        }
    }

    getData() {
        const {zoomedXDomain, maxPoints, data} = this.state;


        let filtered = data.map(entry => entry.filter(
            (d) => (d.x >= zoomedXDomain[0] && d.x <= zoomedXDomain[1])));


        filtered = filtered.map(d => {
            if (d.length > maxPoints) {
                const k = Math.ceil(filtered.length / maxPoints);
                return d.filter(
                    (d, i) => ((i % k) === 0)
                );
            }
            return d
        })
        return filtered;
    }


    render() {
        let dataNotReady = this.state.data==null||this.state.data.length===0||this.state.data[0]==null||this.state.data[0].length === 0
        let renderedData = dataNotReady?[]:this.getData()

        return (
            <div style={styles.container} className={'chartContainer'} onMouseEnter={(e)=> document.body.style.overflow = 'hidden'} onMouseLeave={(e)=>document.body.style.overflow = 'scroll'}>
                <Dropdown style={styles.dropdown} options={[
                    {label: strings.batteryTensionButton, value: 0},
                    {label: strings.batterySocButton, value: 1},
                    {label: strings.cellTensionButton, value: 2},
                    {label: strings.cellTempButton, value: 3}
                ]} onChange={this.setValueType.bind(this)} value={this.state.showing} placeholder="Select" />

                {dataNotReady?(
                    <div style={styles.loader}>
                        <p>{strings.loading}</p>
                        <PulseLoader color={dk_blue}/>
                    </div>
                    ):(

                    <div id={'victoryChart'}>
                        <VictoryChart
                            key={this.state.showing.value}
                            width={this.state.width} height={600}
                            scale={{x: "time"}}
                            domain={this.entireDomain}
                            containerComponent={<VictoryZoomCursorContainer
                                cursorDimension="x"
                                cursorLabelOffset={{ x: 3, y: 3 }}
                                labels={(d)=> `${d.y}`}
                                responsive={true}
                                zoomDimension="x"
                                zoomDomain={this.initialDomain}
                                onZoomDomainChange={this.onDomainChange.bind(this)}
                                minimumZoom={{x: 1000*60*1440}}
                            />}
                        >
                            {renderedData.map((data, i) =>
                            <VictoryLine
                                key={i}
                                style={{
                                    data: {stroke: lineColors[Math.ceil((renderedData.length)/i)|0]}
                                }}
                                data={data} />
                            )}
                        </VictoryChart>
                    </div>

                    )}


            </div>
        );
    }

    filterData(props, filterLevel) {
        let {data, cellData} = props
        switch (this.state.showing.value) {
            case 0 : {
                if(this.seeking !== 0) {
                    this.props.seekHistory()
                    this.seeking = 0
                }
                let d = new Array(Math.floor(data.length / filterLevel))
                let c = 0
                for (let i = 0; i < data.length; i += filterLevel) {
                    d[c] = {
                        x: moment(data[i].createdAt, 'YYYY-MM-DDTHH:mm:ss').toDate(),
                        y: (Math.floor((data[i].upack_avg / 1000) * 100) / 100)
                    }
                    c++;
                }
                return [d];
            }
            case 1 : {
                if(this.seeking !== 0) {
                    this.props.seekHistory()
                    this.seeking = 0
                }
                let d = new Array(Math.floor(data.length / filterLevel))
                let c = 0
                for (let i = 0; i < data.length; i += filterLevel) {
                    d[c] = {
                        x: moment(data[i].createdAt, 'YYYY-MM-DDTHH:mm:ss').toDate(),
                        y: data[i].soc
                    }
                    c++;
                }
                return [d];
            }
            case 2: {
                if(this.seeking !== 1) {
                    this.props.seekCellHistory()
                    this.seeking = 1
                }
                filterLevel *= cellData.length
                return cellData.map(cellHistory => {

                    let d = new Array(Math.floor(cellHistory.states.length / filterLevel))
                    let c = 0
                    for (let i = 0; i < cellHistory.states.length; i += filterLevel) {
                        d[c] = {
                            x: moment(cellHistory.states[i].createdAt, 'YYYY-MM-DDTHH:mm:ss').toDate(),
                            y: cellHistory.states[i].ucell_avg
                        }
                        c++;
                    }
                    return d;
                })
            }
            case 3: {
                if(this.seeking !== 1) {
                    this.props.seekCellHistory()
                    this.seeking = 1
                }
                filterLevel *= cellData.length
                return cellData.map(cellHistory => {

                    let d = new Array(Math.floor(cellHistory.states.length / filterLevel))
                    let c = 0
                    for (let i = 0; i < cellHistory.states.length; i += filterLevel) {
                        d[c] = {
                            x: moment(cellHistory.states[i].createdAt, 'YYYY-MM-DDTHH:mm:ss').toDate(),
                            y: cellHistory.states[i].temp
                        }
                        c++;
                    }
                    return d;
                })
            }
            default:
                console.log('Problem selecting graph type ...')
                break;
        }
    }

}

const styles = {
    container: {
        position: 'relative',
    },
    dropdown: {
        height: 100,
        width: 200
    },
    loader: {
        height: 350,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column'
    }
}

function lerpColor(a, b, amount) {
    var ah = parseInt(a.replace(/#/g, ''), 16),
        ar = ah >> 16, ag = ah >> 8 & 0xff, ab = ah & 0xff,
        bh = parseInt(b.replace(/#/g, ''), 16),
        br = bh >> 16, bg = bh >> 8 & 0xff, bb = bh & 0xff,
        rr = ar + amount * (br - ar),
        rg = ag + amount * (bg - ag),
        rb = ab + amount * (bb - ab);

    return '#' + ((1 << 24) + (rr << 16) + (rg << 8) + rb | 0).toString(16).slice(1);
}

let lineColors = [
    dk_blue,
    lerpColor(dk_blue, dk_yellow, 1/8),
    lerpColor(dk_blue, dk_yellow, 2/8),
    lerpColor(dk_blue, dk_yellow, 3/8),
    lerpColor(dk_blue, dk_yellow, 4/8),
    lerpColor(dk_blue, dk_yellow, 5/8),
    lerpColor(dk_blue, dk_yellow, 6/8),
    dk_yellow,
    lerpColor(dk_yellow, dk_gray, 1/8),
    lerpColor(dk_yellow, dk_gray, 2/8),
    lerpColor(dk_yellow, dk_gray, 3/8),
    lerpColor(dk_yellow, dk_gray, 4/8),
    lerpColor(dk_yellow, dk_gray, 5/8),
    lerpColor(dk_yellow, dk_gray, 6/8),
    lerpColor(dk_yellow, dk_gray, 7/8),
    dk_gray
]


const mapStateToProps = state => ({
    data: historySelector(state),
    cellData: cellHistorySelector(state),
    battery: openBatterySelector(state),
    cells: cellsSelector(state),
    seeking: historyseekingSelector(state),
})

export default connect(mapStateToProps, {seekHistory, seekCellHistory})(History);